<template>
    <div class="row">
        <div class="col-md-12">
            <div class="panel panel-default consumptions-list">
                <div class="panel-heading separator">
                    <div class="panel-title">Liste de produits
                    </div>
                </div>
                <div class="panel-body">
                    <slot></slot>
                    <div class="table-responsive" v-if="consumptions.length > 0">
                        <table class="table table-hover table-borderless table-striped" cellspacing="0" width="100%">
                            <thead>
                                <tr>
                                    <th>
                                        Client
                                    </th>
                                    <th>
                                        Agence
                                    </th>
                                    <th>
                                        Produit
                                    </th>
                                    <th>
                                        Référence
                                    </th>
                                    <th>
                                        Date/Heure
                                    </th>
                                    <th class="text-center">
                                        Prix
                                    </th>
                                    <th class="text-center">
                                        Quantité
                                    </th>
                                    <th class="text-center">
                                        Total
                                    </th>
                                    <th class="text-center">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="product in consumptions">
                                    <tr>
                                        <td v-html="product.customer.name"></td>
                                        <td v-html="product.ordering_agency.display_name"></td>
                                        <td v-html="product.offer.name"></td>
                                        <td v-html="product.reference"></td>
                                        <td v-html="product.consumption_date"></td>
                                        <td class="text-center" v-html="computeUnitPrice(product)"></td>
                                        <td class="text-center" v-html="product.quantity"></td>
                                        <td class="text-center" v-html="product.price/100"></td>
                                        <td class="text-center" v-if="product.stored_in_erp">Descendu dans SAP</td>
                                        <td class="text-center" v-else>
                                            <button class="btn btn-warning btn-sm" @click="$emit('remove', product.id)">Supprimer</button>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>

                    <div v-else>
                        <h5 class="text-center light">Pas de données</h5>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [ "consumptions" ],

        methods: {
            computeUnitPrice (product) {
                return (product.price / product.quantity) / 100
            },
        }
    }
</script>


// WEBPACK FOOTER //
// client/components/ConsumptionProducts/ProductsTable.vue